const $             = require('jquery');
const _             = require('underscore');
const referenceTpl  = require('../template/reference_tpl');
const menu          = require('./sidenav');

const fa = {
  codeBranch: require('@fortawesome/pro-light-svg-icons/faCodeBranch').definition,
};

class RelatedArticles {
  constructor({ container, metadata, syncApi }) {
    const meta = metadata.meta; 

    if (!meta.doi || !meta.abstract) return;

    this._syncApi = syncApi;
    this._elem = $(`<div class="related content"></div>`);
    this._relatedMemo = _.memoize(() => syncApi.reader.related({ doi: meta.doi }));

    const renderMemo = _.memoize(() => this._render());
    menu.add({
      id: 'related',
      icon: fa.codeBranch,
      title: 'Related Articles',
      badge: 10,
      render: renderMemo
    });
  }

  _render() {
    if (navigator.onLine) {
      this._showRelated();
    } else {
      this._showOffline();
    }
    return this._elem;
  }

  _showRelated() {
    this._showLoading();
    this._relatedMemo().then(references => {
      references.forEach(ref => {
        if (ref.doi && ! ref.article_url) {
          ref.article_url = `https://doi.org/${ref.doi}`;
        }
      });
      referenceTpl({ references, syncApi: this._syncApi })
        .appendTo(this._elem.empty());
    }).catch(e => console.warn(e));
  }

  _showOffline() {
    this._elem.empty().append(`
      <div class="offline-notice">
        <p>You need to go online to be able to view related articles.</p>
      </div>
    `);
  }

  _showLoading() {
    this._elem.empty().append(`
      <div class="loading-more">
        <div class="loader-inner ball-pulse">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    `);
  }
}

module.exports = RelatedArticles;
